import { InvalidCredentialsError } from "../../../domain/errors/invalid-credentials-error";
import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import { Stack, StackModel } from "../../../domain/models/stacks";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteStack implements Stack {
  constructor(
    private readonly url: string,
    private readonly httpPostClient: HttpClient,
    private readonly baseUrl: string | undefined
  ) {}

  async loadAll(): Promise<StackModel[]> {
    const httpResponse = await this.httpPostClient.request({
      url: `${this.url}`,
      method: "get",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
